import { IApplicationState } from '../../types/redux';
import { selectCoPromos, selectHasBlackFridayOffers, selectListingCompilations } from '../promosPage';

export function selectHasBlackFridayPromos(state: IApplicationState): boolean {
  const hasBlackFridayOffers = selectHasBlackFridayOffers(state);
  const hasCoPromos = selectCoPromos(state).length > 0;
  const hasListingCompilations = selectListingCompilations(state).length > 0;

  return hasBlackFridayOffers || hasCoPromos || hasListingCompilations;
}
